function SocialLinks() {
    return (
        <div className="social-links">
            <a href="https://www.facebook.com/lestroweb/?locale=ru_RU" target="_blank" rel="noreferrer">FB</a>
            {/*<a href="https://www.linkedin.com/company/lestro/about/" target="_blank">IN</a>*/}
        </div>
    );
}

export default SocialLinks;